import * as Yup from 'yup';
export const amountValidation = Yup.number().typeError('ادخل رقم صحيح').min(0, 'يجب ادخال السعر');
